package org.example.project.service

import kotlinx.serialization.Serializable

@Serializable
class UserCsvProfileSettings(
    val screenKey: String = "",
    val profiles: Map<String, Map<String, String>> = emptyMap(),
    val selectedProfile: String = ""
)

@Serializable
class UserLetterProfileSettings(
    val screenKey: String = "",
    val profiles: Map<String, String> = emptyMap(),
    val selectedProfile: String = ""
)
